import { render, staticRenderFns } from "./workFeedback.vue?vue&type=template&id=96ad44e2&scoped=true&"
import script from "./workFeedback.vue?vue&type=script&lang=js&"
export * from "./workFeedback.vue?vue&type=script&lang=js&"
import style0 from "./workFeedback.vue?vue&type=style&index=0&id=96ad44e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ad44e2",
  null
  
)

export default component.exports